export const faqs = [
  {
    question: "How accurate is Transcript Genie's grade conversion process?",
    answer:
      "Transcript Genie uses advanced AI algorithms trained on a vast database of international grading systems. Our system continuously learns and updates to maintain the highest level of accuracy. Additionally, we provide a review interface for admissions officers to verify and adjust conversions if needed.",
  },
  {
    question:
      "Can Transcript Genie handle transcripts from different countries?",
    answer:
      "Yes, Transcript Genie is designed to process transcripts from various countries and educational systems concurrently. This feature allows admissions departments to standardize grades from diverse applicant pools efficiently.",
  },
  {
    question: "How does Transcript Genie protect applicant data?",
    answer:
      "We prioritize data security with end-to-end encryption, regular security audits, and compliance with international data protection regulations. All data is stored in secure, geographically redundant servers to ensure both safety and accessibility.",
  },
  {
    question:
      "What benefits does Transcript Genie offer to our admissions process?",
    answer:
      "Transcript Genie automates the time-consuming task of transcript evaluation, allowing your team to focus on holistic application review. It reduces processing time, minimizes human error, and provides consistent evaluation criteria across all applications.",
  },
  {
    question:
      "Can admissions officers make adjustments to the converted transcripts?",
    answer:
      "Additionally, we provide a review interface for admissions officers to verify and adjust conversions if needed.",
  },
];
